import { displayDay, DisplayTime } from 'common/display-state/display-time.js';
import { IconWithText } from 'common/icon/icon-with-text.js';
import { IMapSlotClose } from 'common/tile/tile-body-header-v2-element.js';
import { TileBodyHeaderV2 } from 'common/tile/tile-body-header-v2.js';
import { Tile } from 'common/tile/tile.js';
import { LinkRef } from 'components-modules/condition/link-ref.js';
import { IModule } from 'redux-state/layout/types.js';
import { DATE_FORMATS } from 'utilities/date.js';

interface IForecastRural {
  date: string;
  lowTemp: number;
  highTemp: number;
  rainFall1?: number;
  rainFall10?: number;
}

export type IUrbanForecastProps = {
  forecasts: IForecastRural[];
  description: string;
};

const Forecast = (props: { forecast: IForecastRural }) => {
  const {
    forecast: { date, highTemp, lowTemp, rainFall1, rainFall10 },
  } = props;

  const showRuralTemps = highTemp !== undefined && highTemp !== null && lowTemp !== null && lowTemp !== undefined;
  const hasRainfallData =
    rainFall1 !== undefined && rainFall1 !== null && rainFall10 !== null && rainFall10 !== undefined;

  return (
    <>
      <h3>
        <span className="u-textUppercase">{displayDay(date, true)}</span>
        &nbsp;
        <DisplayTime classes="u-textRegular" date={date} format={DATE_FORMATS.DateMonth} />
      </h3>

      {showRuralTemps && (
        <div className="u-mB-xs">
          <IconWithText
            icon="temp-high"
            classes="IconWithText--vCenter IconWithText--small IconWithText--tight IconWithText--inline u-pR-sm"
          >
            <span className="u-textRegular">{highTemp}°</span>
          </IconWithText>
          <IconWithText
            icon="temp-low"
            classes="IconWithText--vCenter IconWithText--small IconWithText--tight IconWithText--inline"
          >
            <span className="u-textRegular">{lowTemp}°</span>
          </IconWithText>
        </div>
      )}

      {hasRainfallData && (
        <>
          <IconWithText
            icon="rain-1mm"
            classes="IconWithText--vCenter IconWithText--small IconWithText--tight IconWithText--inline u-pR-sm"
          >
            <p className="fineprint u-mT-0 u-mB-0">
              <strong>1+ mm: </strong>
              {`${rainFall1}%`}
            </p>
          </IconWithText>
          <IconWithText
            icon="rain-10mm"
            classes="IconWithText--vCenter IconWithText--small IconWithText--tight IconWithText--inline u-mB-xs"
          >
            <p className="fineprint u-mT-0 u-mB-0">
              <strong>10+ mm: </strong>
              {`${rainFall10}%`}
            </p>
          </IconWithText>
        </>
      )}
    </>
  );
};

export const UrbanForecast = (props: IModule<IUrbanForecastProps & IMapSlotClose>) => {
  const {
    config: { forecasts, description, link },
  } = props;

  return (
    <Tile dataModule="urban-forecast" {...props}>
      <div className="Tile-body">
        <TileBodyHeaderV2 {...props} onModuleClose={props.config.onModuleClose} />

        <p className="fineprint u-mB-0">{description}</p>

        {forecasts.map((forecast, index) => (
          <Forecast key={index} forecast={forecast} />
        ))}

        <LinkRef link={link} />
      </div>
    </Tile>
  );
};
